<template>
    <div class="num-row">
        <div class="num-item" v-for="(item,index) in list" :key="index">
            <span>{{item.num}}</span>
            <h4>{{item.title}}</h4>
        </div>
    </div>
</template>

<script>
export default {
    name: "numRow",
    props:{
        list:[Array]
    }
}
</script>

<style scoped lang="scss">
//num-row
.num-row{
    display: flex;
    justify-content: space-between;
    .num-item{
        flex:1 0 33.3%;
        text-align: center;
        span{
            @extend .title1;
            margin-bottom: 15px;
            color: $activeColor;
        }
        h4{
            @extend .h4-20px
        }
    }
}

@media only screen and (max-width: 767px) {
    .num-row{
        display: block;
    }
    .num-item+.num-item{
        margin-top: 20px;
    }
    .num-row .num-item span{
        font-size: 48px;
    }
    .num-row .num-item h4{
        font-size: 16px;
        font-weight: normal;
    }
}
</style>
